import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const LEFT_LIST_WIDTH = 375;
const CHAT_LIST_TABS_HEIGHT = 56;
const LIST_HEADER_HEIGHT = 68;
const GNB_HEIGHT = 61;
const LEFT_BOTTOM_NAV_HEIGHT = 56;
const RIGHT_BOTTOM_NAV_HEIGHT = 83;
const MOBILE_HEADER_HEIGHT = 48;
const MOBILE_DETAIL_TABS = 54;
const BORDER_LINE_HEIGHT = 1;

const useStyles = makeStyles(
  ({ breakpoints: { down }, typography, zIndex }) => ({
    'Dashboard-Root': {
      display: 'flex',
      flexWrap: 'nowrap',
      height: '100%'
    },
    'Dashboard-Left-Root': {
      width: LEFT_LIST_WIDTH,
      height: '100%',
      borderRight: `1px solid ${colorSet.gray400}`,
      [down('md')]: {
        width: '100%',
        height: `calc(var(--vh , 1vh) * 100)`
      }
    },
    'Dashboard-Left-header': {
      top: 0,
      position: 'sticky',
      maxHeight: 68,
      borderBottom: `1px solid ${colorSet.gray400}`,
      height: '100%',
      width: '100%',
      maxWidth: LEFT_LIST_WIDTH,
      backgroundColor: colorSet.gray000,
      zIndex: 1010,
      padding: '16px 16px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& button': {
        '& .label': {
          ...typography.body1,
          fontWeight: 500
        },
        '&:hover': {
          textDecoration: 'none'
        }
      },
      [down('md')]: {
        top: 0,
        width: '100%',
        maxWidth: '100%'
      },
      '&.block': {
        position: 'relative',
        zIndex: -1,
        visibility: 'hidden'
      }
    },
    'Dashboard-Left-List': {
      display: 'flex',
      flexDirection: 'column',
      height: `calc(100vh - ${GNB_HEIGHT + LIST_HEADER_HEIGHT}px)`,
      overflow: 'scroll',
      '&.request': {
        position: 'relative',
        backgroundColor: colorSet.gray200,
        borderRight: `1px solid ${colorSet.gray400}`
      },
      '&.chat': {
        height: `calc(100vh - ${
          CHAT_LIST_TABS_HEIGHT + LIST_HEADER_HEIGHT + GNB_HEIGHT
        }px)`
      },

      [down('md')]: {
        height: `calc(100vh - ${LIST_HEADER_HEIGHT + LEFT_BOTTOM_NAV_HEIGHT})`
      }
    },
    'Dashboard-Left-Tabs': {
      position: 'relative',
      maxWidth: 374,
      height: 56,
      width: '100%',
      backgroundColor: colorSet.gray000,
      [down('md')]: {
        maxWidth: '100%'
      },
      '& .MuiTabs-indicator': {
        backgroundColor: `${colorSet.gray900}`
      },
      '& .tabs-block': {
        height: 56,
        width: '100%',
        zIndex: -1,
        position: 'relative'
      },
      '& .tabs': {
        zIndex: 1,
        backgroundColor: colorSet.gray000,
        position: 'fixed',
        width: '100%',
        maxWidth: 374,
        borderBottom: `1px solid ${colorSet.gray200}`,

        [down('md')]: {
          maxWidth: '100%'
        }
      },
      '& .tab': {
        padding: 16,
        width: '100%',
        maxWidth: 'calc(100% / 2)',
        minWidth: 125,
        minHeight: 56,
        '& .tab-wrapper': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          '& .label': {
            ...typography.body1,
            fontWeight: 500
          },
          '& .MuiChip-root': {
            width: 27,
            height: 20,
            marginLeft: 4,
            color: colorSet.gray000,
            backgroundColor: '#ff7f7c',
            '& .MuiChip-label': {
              padding: 0
            }
          }
        }
      }
    },
    'Dashboard-Right-Root': {
      width: `calc(100% - ${LEFT_LIST_WIDTH}px)`,
      overflow: 'auto',
      transition: ' width 0.2s ease-in-out'
    },
    'Dashboard-Right-Action-CTA': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      position: 'fixed',
      backgroundColor: colorSet.gray000,
      borderTop: `1px solid ${colorSet.gray400}`,
      padding: '16px 24px',
      width: `calc(100% - ${LEFT_LIST_WIDTH}px)`,
      height: RIGHT_BOTTOM_NAV_HEIGHT,
      bottom: 0,
      right: 0,
      gap: '16px',
      zIndex: 1,
      [down('md')]: {
        width: '100%',
        flexDirection: 'column'
      },
      '& .buttonsContainer': {
        display: 'flex',
        gap: '8px',
        [down('md')]: {
          width: '100%',
          gap: '12px'
        }
      },
      '& .cta': {
        width: 196,
        [down('md')]: {
          width: '100%'
        }
      },
      '& .quotation': {
        marginRight: 'auto',
        '& b': {
          color: colorSet.gray900
        }
      },
      '& .quotation-text-button': {
        marginRight: 'auto',
        '& strong': {
          color: colorSet.primary500
        },
        [down('md')]: {
          display: 'none'
        }
      },
      '&.block': {
        width: '100%',
        minHeight: RIGHT_BOTTOM_NAV_HEIGHT,
        position: 'relative',
        zIndex: -1,
        visibility: 'hidden',
        bottom: 0,
        maxWidth: '100%'
      }
    },
    'Dashboard-Portal': {
      overflow: 'scroll',
      width: '100%',
      position: 'fixed',
      backgroundColor: colorSet.gray000,
      zIndex: zIndex.drawer + 50,
      top: 0,
      height: '100%',
      '&.chat': {
        paddingBottom: 0
      }
    },
    'Dashboard-Right-Detail-Root': {
      paddingTop: '24px',
      minHeight: `calc(100vh - ${GNB_HEIGHT}px - ${RIGHT_BOTTOM_NAV_HEIGHT}px)`,
      width: '600px',
      [down('md')]: {
        width: 'unset',
        minHeight: `calc(100vh - ${RIGHT_BOTTOM_NAV_HEIGHT}px)`,
        paddingTop: `${MOBILE_HEADER_HEIGHT}px`
      }
    },
    'Dashboard-Right-Detail-Tabs': {
      width: '100%',
      height: 55,
      borderBottom: `1px solid ${colorSet.gray200}`,
      '& .MuiTabs-scroller': {
        display: 'flex'
      },
      '& .MuiTab-wrapper': {
        ...typography.body1,
        fontWeight: 500,
        color: colorSet.gray700
      },
      '& .Mui-selected .MuiTab-wrapper': {
        fontWeight: 700,
        color: colorSet.gray900
      },
      '& .MuiTabs-indicator': {
        backgroundColor: colorSet.gray900
      },
      [down('md')]: {
        '& .MuiTab-root': {
          minWidth: '172px'
        },
        '& .MuiTabs-scroller': {
          justifyContent: 'center'
        }
      }
    },
    'Dashboard-Right-Detail-Mobile-Header': {
      width: '100%',
      position: 'absolute',
      top: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      borderBottom: `1px solid ${colorSet.gray400}`,
      '& button': {
        padding: 0
      },
      '& .mobile-header-organization-name': {
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%)'
      },
      '& .breakpoints-down-600-link-button': {
        display: 'none',
        [down('xs')]: {
          display: 'block'
        }
      }
    },
    'Dashboard-Right-Detail-Header': {
      display: 'flex',
      width: '100%',
      zIndex: zIndex.drawer - 1,
      position: 'fixed',
      maxHeight: 49,
      height: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: `1px solid ${colorSet.gray200}`,
      backgroundColor: colorSet.gray000,
      padding: '12px 16px',
      maxWidth: `calc(100% - ${LEFT_LIST_WIDTH}px)`,
      top: GNB_HEIGHT,

      [down('md')]: {
        top: 0,
        left: 0,
        maxWidth: '100%'
      },
      '& > p': {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)'
      },
      '& .close': {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '& button': {
          padding: 0,
          marginRight: 2
        },
        '& svg': {
          width: 24,
          height: 24,
          color: colorSet.gray900
        }
      },
      '&.block': {
        width: '100%',
        minHeight: 49,
        position: 'relative',
        zIndex: -1,
        visibility: 'hidden',
        top: 0,
        maxWidth: '100%',
        '&.guttuerBottom': {
          marginBottom: 24,
          [down('md')]: {
            marginBottom: 0
          }
        }
      }
    },
    'Quotation-root': {
      position: 'relative',
      width: '100%',
      minHeight: `calc(100vh - ${GNB_HEIGHT}px - ${MOBILE_DETAIL_TABS}px - ${
        BORDER_LINE_HEIGHT + RIGHT_BOTTOM_NAV_HEIGHT
      }px - 24px)`,

      [down('md')]: {
        minHeight: `calc(100vh - ${
          MOBILE_HEADER_HEIGHT + BORDER_LINE_HEIGHT
        }px - ${MOBILE_DETAIL_TABS}px - ${
          BORDER_LINE_HEIGHT + RIGHT_BOTTOM_NAV_HEIGHT
        }px)`
      }
    },
    'no-quotation-wrapper': {
      minHeight: 'inherit',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: '32px',
      margin: `0px 32px`,

      '& .no-quotation-image': {
        width: 137,
        height: 137
      }
    },
    'companyinfoRequest': {
      width: '100%',
      '& .company-Info-detail': {
        padding: '0px 16px !important',
        borderRadius: '0 0 16px 16px !important',
        [down('xs')]: {
          padding: '0px !important',
          borderRadius: '0 0 16px 16px !important'
        }
      }
    }
  })
);

export default useStyles;
